import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FORMULAS_STATE_KEY, type FormulasState } from './formulas.state';

export const selectFormulasState = createFeatureSelector<FormulasState>(FORMULAS_STATE_KEY);

export const selectFormulaFunctions = createSelector(
  selectFormulasState,
  (state: FormulasState) => state.formulaFunctions,
);
